import axios from "axios";
import { SignUpData } from "../../api-types/sign-up";
import { SIGN_UP_URL } from "../utils";

export const signUp = async (signUpData: SignUpData) => {
  return await axios.post(SIGN_UP_URL, signUpData);
};
